<template>
    <ContactUsPage :nav-bar-show-logo-text="false" form-type="contactus">
        <h1 class="font-large font-extrabold text-blue text-2xl lg:text-left lg:text-3xl">
            Contact Us
        </h1>
        <article class="text-grey-70">
            <p class="mb-4 font-extrabold">
                Let us know what we can do for you
            </p>
            <p class="mb-4">
                Agency Central is visited by over
                <span class="font-bold">
                    25,000 employers
                </span>
                and over
                <span class="font-bold">
                    425,000 candidates
                </span>
                <span class="font-bold text-green-10">
                    every month
                </span>
                - making us the place to be whether you’re trying to find a new job or whether you’re looking to fill a position.
            </p>
            <p class="mb-4">
                Contact us either by phone or by using the form below, and find out more.
            </p>
            <div class="p-4 mb-4 rounded-lg bg-grey-20">
                <p class="font-bold">
                    Whether you’re from an employer trying to find a recruitment agency to work with, an agency looking to advertise on our site, or you’d just like to speak to us, then the Agency Central team would love to hear from you.
                </p>
            </div>
        </article>
    </ContactUsPage>
</template>

<script>
import InputButton from "Components/InputButton.vue"
import IconChevronRight from "Components/Icons/IconChevronRight";
import ContactUsPage from "Components/layouts/ContactUsPage";
import NavBar from "Components/NavBar/NavBar";
import InputText from "Components/InputText.vue";
import PageBreadcrumb from 'Components/PageBreadcrumb';

export default {
    name: "Contact",
    components: {
        InputButton,
        IconChevronRight,
        ContactUsPage,
        NavBar,
        InputText,
        PageBreadcrumb,
    },
};
</script>
